





import Vue from 'vue'

export default Vue.extend({
  name: 'EmptyRouterParent',
  data() {
    return {
      cachedComponents: ['CustomersPage', 'LeadsPage']
    }
  }
})
